import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { updateJobTransaction } from "../docuclipper/api";
import { useSelector } from "react-redux";
import { ReduxState } from "../redux";

type Props = { value; onValueChange; eventKey; stopEditing; data };
export const CreatableAgGridCellRenderer: React.FC<Props> = ({
  //   value,
  onValueChange,
  eventKey,
  stopEditing,
  data,
}) => {
  const { job } = useSelector((state: ReduxState) => state.JobData);

  const [options, setOptions] = useState(
    (data.tags || []).map((t) => ({ label: t, value: t }))
  );
  const [value, setValue] = useState(options);

  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === "create-option") {
      setOptions(newValue);
    }
    setValue(newValue);

    if (job) {
      updateJobTransaction(job.id, data.id, {
        tags: newValue.map((x) => x.value),
      })
        // .then(() => dispatch(getCategoriesAction()))
        .then(() => null)
        .catch((err) => null);
    }
    // onValueChange(newValue);
  };

  return (
    <div>
      <CreatableSelect
        placeholder="Create new tag"
        isMulti
        onChange={handleChange}
        options={options}
        value={value}
      />
    </div>
  );
};

export default CreatableAgGridCellRenderer;
